import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import ConfirmDeleteModal from './ConfirmationModelDelete';

const ListAttribute = () => {
  const [userData, setUserData] = useState([]);
  const token = localStorage.getItem('authToken');
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const history = useHistory();

  const getData = async () => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/superadmin/attribute`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

 
      setUserData(response?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (e, id) => {
    history.push(`/edit-attribute/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://brand.aasmo.in/api/superadmin/attribute/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Attribute</h2>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
              
                <th>Name</th>
             
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {userData.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                 
                  <td>{user.name}</td>
                
                  <td>{formatDate(user.createdAt)}</td>
                  <td>
                    <i className="icon-pencil" onClick={(e) => handleEdit(e, user.id)}></i>
                    &nbsp;&nbsp;
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user.id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ConfirmDeleteModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleConfirm={() => handleDelete(selectedUserId)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(ListAttribute);
